// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.component {
  display: flex;
  background-color: var(--app-main-darker);
}
.component .side {
  /*&:not(:last-of-type) {
    border-right: 1px solid var(--app-main-softer);
  }*/
}
.component .side.side-left {
  flex: 1;
  padding: 6px 15px;
  padding-right: 10px;
  display: flex;
}
.component .side.side-left .btns-wrap {
  display: flex;
  align-items: center;
}
.component .side.side-left .btns-wrap.btns-wrap-1 .tb-btn {
  margin: 0;
  --border-radius: 50%;
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
  position: relative;
}
.component .side.side-left .btns-wrap.btns-wrap-1 .tb-btn .td-btn-inner {
  padding: 8px;
  display: flex;
}
.component .side.side-left .btns-wrap.btns-wrap-1 .tb-btn .td-btn-inner .btn-icon {
  font-size: 30px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 {
  flex: 1;
  padding: 0 15px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn {
  margin: 0;
  --border-radius: 6px;
  border-radius: 6px;
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn .td-btn-inner {
  padding: 8px 12px 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn .td-btn-inner .btn-icon {
  font-size: 28px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn .td-btn-inner .btn-lbl {
  padding-top: 9px;
  font-size: 12px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn:not(:last-child) {
  margin-right: 7px;
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn.selected {
  background-color: var(--app-main-strong);
}
.component .side.side-left .btns-wrap.btns-wrap-2 .tb-btn.selected .td-btn-inner {
  cursor: auto;
}
.component .side.side-left .btns-wrap.btns-wrap-3 {
  border-left: 2px solid var(--app-mid-light);
  padding-left: 15px;
  /*.tb-btn {
    margin: 0;

    --border-radius: 6px;

    --padding-start: 0;
    --padding-end: 0;

    height: auto;


    .td-btn-inner {
      padding: 5px 10px;

      display: flex;
      align-items: center;

      .btn-icon {
        font-size: 22px;
      }

      .btn-lbl {
        padding-left: 5px;

        //font-weight: 600;
        text-transform: none;
      }
    }//.td-btn-inner


    &:not(:last-child) {
      //margin-right: 5px; // never tried out
      margin-right: 10px;
    }

  }*/
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn {
  margin: 0;
  --border-radius: 6px;
  --padding-start: 0;
  --padding-end: 0;
  height: auto;
  /*&.selected {
    background-color: var(--app-main-strong);

    .td-btn-inner {
      cursor: auto;
    }
  }*/
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn .td-btn-inner {
  padding: 8px 12px 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn .td-btn-inner .btn-icon {
  font-size: 28px;
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn .td-btn-inner .btn-lbl {
  padding-top: 9px;
  font-size: 12px;
}
.component .side.side-left .btns-wrap.btns-wrap-3 .tb-btn:not(:last-child) {
  margin-right: 7px;
}
.component .side.side-right .recipient-topbar-inner {
  padding: 8px 0;
  padding-left: 10px;
  padding-right: 20px;
  min-height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  /*.recipient-body {
    flex: 1;
    padding: 0 15px;

    display: flex;
    align-items: center;

    // infos (lines)
    .rb-infos {
      width: 100%;
      display: flex;


      .info-col {
        display: flex;

        .info-row {
          display: flex;
          align-items: center;


          .info-part {

            &.ip-name {
              display: grid;

              .name-text {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                color: #fff;
                font-size: 15px;
                font-weight: 500;

                // to balance emojis height
                line-height: 18px; !* normal text's height, no emojis *!
              }
            }//&.ip-name


            &.ip-last-seen {
              display: grid;

              .last-seen-text {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                color: #fff;

                font-size: 14px;
                // to balance emojis height
                line-height: 16px; !* normal text's height, no emojis *!
              }
            }//&.ip-last-seen

          }//.info-part


          !*&:not(:last-child) {
            margin-bottom: 4px;
          }*!

          &.info-row-1 {
            margin-bottom: 2px;
          }
        }//.info-row


        &.info-col-main {
          padding-right: 15px;
          flex: 1;

          flex-direction: column;
          justify-content: center;
        }

        &.info-col-actions {
          align-items: center;

          .action-btn {
            margin: 0;
            --border-radius: 50%;

            --padding-top: 5px;
            --padding-bottom: 5px;
            --padding-start: 5px;
            --padding-end: 5px;

            height: auto;

            font-size: 12px;

            .action-btn-icon {
              margin-bottom: -2px;
              margin-top: 2px;
            }

            !*&:last-child {
              margin-right: -5px;
            }*!
          }//.action-btn

        }//&.info-col-actions


      }//.info-col


    }//.rb-infos
  }*/
}
.component .side.side-right .recipient-topbar-inner .recipient-head .rec-avatar {
  border-radius: 50%;
  overflow: hidden;
  height: 50px;
  width: 50px;
  background-color: var(--app-main);
  display: flex;
}
.component .side.side-right .recipient-topbar-inner .recipient-head .rec-avatar .avatar-pic {
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.component .side.side-right .recipient-topbar-inner .recipient-head .rec-avatar .avatar-lbl {
  align-self: center;
  width: 100%;
  margin: 0 8px;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-user-select: none;
  user-select: none;
}
.component .side.side-right .recipient-topbar-inner .recipient-head .rec-avatar .avatar-lbl.sm {
  margin: 0 5px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/top-bar/top-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wCAAA;AACF;AACE;EA8YE;;IAAA;AA1YJ;AAFI;EACE,OAAA;EAEA,iBAAA;EACA,mBAAA;EAGA,aAAA;AACN;AAEM;EACE,aAAA;EACA,mBAAA;AAAR;AAKU;EACE,SAAA;EACA,oBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,YAAA;EAEA,kBAAA;AANZ;AAOY;EACE,YAAA;EACA,aAAA;AALd;AAOc;EACE,eAAA;AALhB;AAaQ;EACE,OAAA;EAGA,eAAA;AAbV;AAeU;EACE,SAAA;EAEA,oBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,YAAA;AAhBZ;AAmBY;EACE,qBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;AAlBd;AAqBc;EACE,eAAA;AAnBhB;AAsBc;EACE,gBAAA;EAEA,eAAA;AArBhB;AA6BY;EACE,iBAAA;AA3Bd;AA8BY;EACE,wCAAA;AA5Bd;AA8Bc;EACE,YAAA;AA5BhB;AAoCQ;EACE,2CAAA;EACA,kBAAA;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAAA;AAAV;AAoCU;EACE,SAAA;EAEA,oBAAA;EAGA,kBAAA;EACA,gBAAA;EAEA,YAAA;EA8BA;;;;;;IAAA;AA7DZ;AAkCY;EACE,qBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;AAjCd;AAoCc;EACE,eAAA;AAlChB;AAqCc;EACE,gBAAA;EAEA,eAAA;AApChB;AA4CY;EACE,iBAAA;AA1Cd;AAkEM;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EAEA,gBAAA;EAEA,aAAA;EACA,mBAAA;EAEA,eAAA;EAuEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAAA;AA1BR;AAnCU;EAIE,kBAAA;EACA,gBAAA;EAGA,YAAA;EACA,WAAA;EACA,iCAAA;EAEA,aAAA;AA+BZ;AA3BY;EACE,WAAA;EAEA,4BAAA;EACA,2BAAA;EACA,sBAAA;AA4Bd;AAxBY;EACE,kBAAA;EACA,WAAA;EAEA,aAAA;EAGA,WAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EAIA,mBAAA;EACA,gBAAA;EACA,uBAAA;EAGA,yBAAA;EAGA,iBAAA;AAiBd;AAdc;EACE,aAAA;EACA,eAAA;AAgBhB","sourcesContent":[".component {\n  display: flex;\n  background-color: var(--app-main-darker);\n\n  .side {\n\n    &.side-left {\n      flex: 1;\n\n      padding: 6px 15px;\n      padding-right: 10px;\n\n      //background-color: var(--app-main);\n      display: flex;\n\n\n      .btns-wrap {\n        display: flex;\n        align-items: center;\n\n\n        &.btns-wrap-1 {\n\n          .tb-btn {\n            margin: 0;\n            --border-radius: 50%;\n\n            --padding-start: 0;\n            --padding-end: 0;\n\n            height: auto;\n\n            position: relative;\n            .td-btn-inner {\n              padding: 8px;\n              display: flex;\n\n              .btn-icon {\n                font-size: 30px;\n              }\n            }//.td-btn-inner\n          }//.tb-btn\n\n        }//&.btns-wrap-1\n\n\n        &.btns-wrap-2 {\n          flex: 1;\n\n          //padding: 0 20px;\n          padding: 0 15px;\n\n          .tb-btn {\n            margin: 0;\n\n            --border-radius: 6px;\n            border-radius: 6px; // useful when selected\n\n            --padding-start: 0;\n            --padding-end: 0;\n\n            height: auto;\n\n\n            .td-btn-inner {\n              padding: 8px 12px 7px;\n\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n\n\n              .btn-icon {\n                font-size: 28px;\n              }\n\n              .btn-lbl {\n                padding-top: 9px;\n\n                font-size: 12px;\n                //font-weight: 600;\n\n                //text-transform: none;\n              }\n            }//.td-btn-inner\n\n\n            &:not(:last-child) {\n              margin-right: 7px;\n            }\n\n            &.selected {\n              background-color: var(--app-main-strong);\n\n              .td-btn-inner {\n                cursor: auto;\n              }\n            }//&.selected\n          }//.tb-btn\n\n        }//&.btns-wrap-2\n\n\n        &.btns-wrap-3 {\n          border-left: 2px solid var(--app-mid-light);\n          padding-left: 15px;\n\n          /*.tb-btn {\n            margin: 0;\n\n            --border-radius: 6px;\n\n            --padding-start: 0;\n            --padding-end: 0;\n\n            height: auto;\n\n\n            .td-btn-inner {\n              padding: 5px 10px;\n\n              display: flex;\n              align-items: center;\n\n              .btn-icon {\n                font-size: 22px;\n              }\n\n              .btn-lbl {\n                padding-left: 5px;\n\n                //font-weight: 600;\n                text-transform: none;\n              }\n            }//.td-btn-inner\n\n\n            &:not(:last-child) {\n              //margin-right: 5px; // never tried out\n              margin-right: 10px;\n            }\n\n          }*///.tb-btn\n          .tb-btn {\n            margin: 0;\n\n            --border-radius: 6px;\n            //border-radius: 6px; // useful when selected\n\n            --padding-start: 0;\n            --padding-end: 0;\n\n            height: auto;\n\n\n            .td-btn-inner {\n              padding: 8px 12px 7px;\n\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n\n\n              .btn-icon {\n                font-size: 28px;\n              }\n\n              .btn-lbl {\n                padding-top: 9px;\n\n                font-size: 12px;\n                //font-weight: 600;\n\n                //text-transform: none;\n              }\n            }//.td-btn-inner\n\n\n            &:not(:last-child) {\n              margin-right: 7px;\n            }\n\n            /*&.selected {\n              background-color: var(--app-main-strong);\n\n              .td-btn-inner {\n                cursor: auto;\n              }\n            }*///&.selected\n          }//.tb-btn\n\n        }//&.btns-wrap-3\n\n\n      }//.btns-wrap\n\n    }//&.side-left\n\n\n    &.side-right {\n      //max-width: 400px;\n      //background-color: var(--app-main-strong);\n\n      .recipient-topbar-inner {\n        padding: 8px 0;\n        padding-left: 10px;\n        padding-right: 20px;\n\n        min-height: 100%;\n\n        display: flex;\n        align-items: center;\n\n        cursor: pointer;\n\n\n        .recipient-head {\n          //padding-left: 20px;\n\n          //display: flex;\n          //align-items: center;\n\n          // recipient's avatar\n          .rec-avatar {\n            //box-sizing: content-box;\n            //border: 2px solid var(--app-succ);\n\n            border-radius: 50%;\n            overflow: hidden;\n\n\n            height: 50px;\n            width: 50px;\n            background-color: var(--app-main);\n\n            display: flex;\n\n\n            // picture\n            .avatar-pic {\n              width: 100%;\n\n              background-repeat: no-repeat;\n              background-position: center;\n              background-size: cover;\n            }\n\n            // initials\n            .avatar-lbl {\n              align-self: center;\n              width: 100%;\n\n              margin: 0 8px;\n\n\n              color: #fff;\n              font-size: 17px;\n              font-weight: 600;\n\n              text-align: center;\n              //text-transform: uppercase;\n\n\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n\n\n              -webkit-user-select: none;\n              -moz-user-select: none;\n              -ms-user-select: none;\n              user-select: none;\n\n\n              &.sm {\n                margin: 0 5px;\n                font-size: 14px;\n              }\n            }//.avatar-lbl\n\n          }//.rec-avatar\n        }//.recipient-head\n\n\n        /*.recipient-body {\n          flex: 1;\n          padding: 0 15px;\n\n          display: flex;\n          align-items: center;\n\n          // infos (lines)\n          .rb-infos {\n            width: 100%;\n            display: flex;\n\n\n            .info-col {\n              display: flex;\n\n              .info-row {\n                display: flex;\n                align-items: center;\n\n\n                .info-part {\n\n                  &.ip-name {\n                    display: grid;\n\n                    .name-text {\n                      white-space: nowrap;\n                      overflow: hidden;\n                      text-overflow: ellipsis;\n\n                      color: #fff;\n                      font-size: 15px;\n                      font-weight: 500;\n\n                      // to balance emojis height\n                      line-height: 18px; !* normal text's height, no emojis *!\n                    }\n                  }//&.ip-name\n\n\n                  &.ip-last-seen {\n                    display: grid;\n\n                    .last-seen-text {\n                      white-space: nowrap;\n                      overflow: hidden;\n                      text-overflow: ellipsis;\n\n                      color: #fff;\n\n                      font-size: 14px;\n                      // to balance emojis height\n                      line-height: 16px; !* normal text's height, no emojis *!\n                    }\n                  }//&.ip-last-seen\n\n                }//.info-part\n\n\n                !*&:not(:last-child) {\n                  margin-bottom: 4px;\n                }*!\n\n                &.info-row-1 {\n                  margin-bottom: 2px;\n                }\n              }//.info-row\n\n\n              &.info-col-main {\n                padding-right: 15px;\n                flex: 1;\n\n                flex-direction: column;\n                justify-content: center;\n              }\n\n              &.info-col-actions {\n                align-items: center;\n\n                .action-btn {\n                  margin: 0;\n                  --border-radius: 50%;\n\n                  --padding-top: 5px;\n                  --padding-bottom: 5px;\n                  --padding-start: 5px;\n                  --padding-end: 5px;\n\n                  height: auto;\n\n                  font-size: 12px;\n\n                  .action-btn-icon {\n                    margin-bottom: -2px;\n                    margin-top: 2px;\n                  }\n\n                  !*&:last-child {\n                    margin-right: -5px;\n                  }*!\n                }//.action-btn\n\n              }//&.info-col-actions\n\n\n            }//.info-col\n\n\n          }//.rb-infos\n        }*///.recipient-body\n\n\n      }//.recipient-topbar-inner\n    }//&.side-right\n\n\n    /*&:not(:last-of-type) {\n      border-right: 1px solid var(--app-main-softer);\n    }*/\n  }//.side\n\n\n}//.component\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
